import { PurchaseOrderStatusEnums } from '../lib/enums';
import { BaseModel, PageableResponse } from './index';
import dayjs from 'dayjs';
import { dateFormat } from '../lib/utils';

export interface PurchaseOrder {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: string;
  status: PurchaseOrderStatusEnums;
  code: string;
  requiredDate: string;
  issuedDate: string;
  source: string;
  proderNo: string;
  sku: string;
  type: string;
  notes: string;
  vendor?: BaseModel;
  destination?: BaseModel;
}

export interface PurchaseOrderInfo {
  files: any;
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  orderDate: string;
  requiredDate: string;
  source: string;
  notes: string;
  vendor: BaseModel;
  destination: BaseModel;
  status: PurchaseOrderStatusEnums;
  preparedBy: string;
  approvedBy: string;
  approvedDate: string;
  preparedDate: string;
  currency: string;
  terms: BaseModel;
  orderLines: OrderLine[];
}

export interface OrderLine {
  id: string;
  uuid: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  description: string;
  product: BaseModel;
  quantity: number;
  productUom: BaseModel;
  status: string;
  unitPrice: number;
  totalAmount: number;
}

export const initialData: PageableResponse<PurchaseOrder> = {
  start: 1,
  length: 99999,
  recordsTotal: 0,
  recordsFiltered: 1,
  data: [],
};

export const initialPurchaseOrderForm = {
  files: undefined,
  id: '',
  code: '',
  orderDate: dayjs(new Date()).format(dateFormat),
  requiredDate: dayjs(new Date()).format(dateFormat),
  source: '',
  notes: '',
  vendor: undefined,
  terms: undefined,
  destination: undefined,
  currency: 'PHP',
  status: 'DRAFT',
  orderLines: [],
};

export interface PurchaseOrderForm {
  files: any | undefined;
  id: string;
  code: string;
  orderDate: string;
  requiredDate: string;
  source: string;
  notes: string;
  vendor: BaseModel | undefined;
  terms: BaseModel | undefined;
  destination: BaseModel | undefined;
  currency: string;
  status: string;
  orderLines: OrderLineForm[];
}

export interface PurchaseOrderStatusForm {
  status: string;
  remarks: string;
}

export interface OrderLineForm {
  id: string | null | undefined;
  uuid: string;
  description?: string | null | undefined;
  product: BaseModel | undefined;
  quantity: number;
  totalAmount: number;
  unitPrice: number;
  productUom: BaseModel | undefined;
}

export interface PurchaseOrderTerm {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  description: string;
}

export const PONextStatus = (poStatus?: PurchaseOrderStatusEnums) => {
  let newStatus: any;
  switch (poStatus) {
    case 'DRAFT':
      newStatus = 'CONFIRM';
      break;
    case 'CONFIRM':
      newStatus = 'APPROVED';
      break;
    // case 'APPROVED':
    //   newStatus = 'READY';
    //   break;
    // case 'READY':
    //   newStatus = 'DONE';
    //   break;
    default:
      newStatus = poStatus;
      break;
  }
  return newStatus;
};
